import { ColumnBibRowSpan, ColumnNameRowSpan, ColumnMinsRowSpan, ColumnGoalShotsColSpan, ColumnStealsRowSpan, ColumnReboundsRowSpan, ColumnBlockedShotsRowSpan, ColumnSprintsRowSpan, ColumnTurnoversFoulsRowSpan, ColumnPersonalFoulsColSpan, ColumnSavesShotsColSpan } from "./TableColumns";

export function FieldStatsColumns() {
    return [
        ColumnBibRowSpan({}),
        ColumnNameRowSpan({}),
        ColumnMinsRowSpan({}),
        ColumnGoalShotsColSpan({}),
        ColumnTurnoversFoulsRowSpan({}),
        ColumnStealsRowSpan({}),
        ColumnReboundsRowSpan({}),
        ColumnBlockedShotsRowSpan({}),
        ColumnSprintsRowSpan({}),
        ColumnPersonalFoulsColSpan({})
    ];
}

export function GoalKeeperStatsColumns({ isMobile: isMobile }) {
    return [
        ColumnBibRowSpan({}),
        ColumnNameRowSpan({ label: "HeaderGoalkeepers" }),
        ColumnSavesShotsColSpan({ isMobile: isMobile })
    ];
}